import { Dispatch } from 'duck/store'
import React from 'react'
import { connect } from 'react-redux'
import { markDealAsNew } from 'scenes/Dashboard/data/deals/actions'
import { Deal } from 'scenes/Dashboard/data/deals/types'

import { Button } from '@mui/material'

const ResetFreshnessButton: React.SFC<ResetFreshnessButtonProps> = ({ onClick, className }) => {
  return (
    <Button className={className} size="small" color="secondary" variant="outlined" onClick={onClick}>
      Mark as new
    </Button>
  )
}

export type ResetFreshnessButtonProps = {
  className?: string
  onClick?: () => any
}

type DispatchProps = Pick<ResetFreshnessButtonProps, 'onClick'>

type ContainerProps = {
  dealId: Deal['id']
}

function mapDispatchToProps(dispatch: Dispatch, { dealId }: ContainerProps): DispatchProps {
  return {
    onClick: () => dispatch(markDealAsNew.request(dealId)),
  }
}

export default connect(undefined, mapDispatchToProps)(ResetFreshnessButton)
